import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type StateType = {
  isDrawerExpanded: boolean;
  setIsDrawerExpanded: (isDrawerExpanded: boolean) => void;
};

export const useDrawerSlice = create<StateType>()(
  devtools(
    (set) => ({
      isDrawerExpanded: false,
      setIsDrawerExpanded: (isDrawerExpanded) =>
        set({ isDrawerExpanded }, false, 'setIsDrawerExpanded'),
    }),
    { name: 'Drawer Store' }
  )
);
